import Vue from 'vue'
import VueRouter from 'vue-router'
import menuRotes from './routes/menu'
import ticketingRotes from './routes/ticketing'
import { getIsTicketing } from '@/utils/helpers'
import store from '../store/index'

Vue.use(VueRouter)

const isTicketing = getIsTicketing()

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior(to, from) {
		const { name: toName, path: toPath, meta = {} } = to
		const { name: fromName, path: fromPath } = from

		if (
			toPath === fromPath ||
			(toName === fromName && meta.preserveScrollOnParamChange) // Disable scroll reset for product scrolls by navigation
		) {
			return false
		}

		return { x: 0, y: 0 }
	},
	routes: isTicketing ? ticketingRotes : menuRotes
})

router.beforeEach((to, from, next) => {
	if (isTicketing) {
		// TODO: Change logic after removing reloading pages
		if (from.name === 'order') {
			return false
		}

		next()
	} else {
		const isWaitingPos = store.getters['cart/isWaitingPos']
		const isTabNotEditable = store.getters['cart/isTabNotEditable']
		const isTabFailed = store.state.cart?.isTabFailed

		if (
			from.name === 'processing' &&
			to.name !== 'processing' &&
			isWaitingPos &&
			!isTabFailed
		) {
			return false
		}

		if (from.name === 'check' && to.name !== 'check' && isTabNotEditable) {
			return false
		}

		next()
	}
})

export default router
